import React from 'react';
import './App.css';

import { SlideShow } from './components/SlideShow';

import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <SlideShow />
      </div>
    </BrowserRouter>
  );
}

export default App;
